import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import "../../assets/css/stepperVertical.css";

export default function StepperVertical({ steps = [], activeStep = 1, setActiveStep, children, onSubmit, hideButton = false }) {
    const contentRef = useRef(null);

    const nextStep = () => {
        const errors = steps[activeStep - 1].validateStep ? steps[activeStep - 1].validateStep() : false;
        if (!errors || errors.length === 0) {
            if (activeStep >= steps.length && onSubmit) {
                onSubmit();
            }
            setActiveStep(activeStep >= steps.length ? activeStep : activeStep + 1);
        }
    };

    const previousStep = () => setActiveStep(activeStep >= 2 ? activeStep - 1 : activeStep);

    // Rola para o topo do conteúdo sempre que o activeStep mudar
    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [activeStep]);

    return (
        <div className="d-flex flex-column flex-md-row mt-4">
            <div className="vertical-stepper steps-container d-flex flex-column align-items-start">
                {steps.map((value, key) => {
                    const isActiveStep = activeStep === key + 1;
                    const isCompletedStep = activeStep >= key + 1;

                    return (
                        <div
                            className={`step d-flex align-items-center w-100 p-2 text-secondary ${isActiveStep ? 'active bg-white' : ''} ${isCompletedStep ? 'completed' : ''}`}
                            style={isActiveStep ? { borderBottomLeftRadius: "20px", borderTopLeftRadius: "20px" } : {}}
                            key={key}
                        >
                            <div className="step-icon d-flex align-items-center justify-content-center me-3"
                                style={{
                                    color: "#fff",
                                    borderRadius: "50%",
                                    width: "85px",
                                    height: "55px",
                                    fontSize: "24px",
                                    backgroundColor: isActiveStep || isCompletedStep ? "#28a745" : "#6c757d"
                                }}>
                                <FontAwesomeIcon icon={value.icon} />
                            </div>

                            <div className="step-content flex-grow-1" style={{ width: "100%" }}>
                                <h5 style={{
                                    fontSize: "10pt",
                                    overflow: "hidden",
                                    wordWrap: "break-word",
                                }}>
                                    {value.text}
                                </h5>
                            </div>

                        </div>
                    );
                })}
            </div>

            <div className="stepper-content-container-vertical flex-grow-1 bg-white w-100 p-3" ref={contentRef} style={activeStep == 1 ? { borderTopRightRadius: "0px" } : { borderRadius: "20px" }}>
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="m-3 fw-normal">
                        <FontAwesomeIcon icon={steps[activeStep - 1].icon} className={"me-3"} />
                        {steps[activeStep - 1].text}
                    </h4>
                    {steps[activeStep - 1].btnAdicionar &&
                        <Button color='primary' className='me-4 fw-bold bg-gradient d-flex align-items-center' onClick={steps[activeStep - 1].btnAdicionar}>
                            {steps[activeStep - 1].btnAdicionarText || "+ Adicionar"}
                        </Button>
                    }
                </div>

                <div className="step-content">
                    {children}
                </div>

                {!hideButton &&
                    <div className='d-flex align-items-center justify-content-center mt-4'>
                        {activeStep !== 1 &&
                            <Button outline color='success' className='me-4 bg-gradient d-flex align-items-center' onClick={previousStep}>
                                <FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior
                            </Button>
                        }
                        <Button color='success' className='bg-gradient d-flex align-items-center' onClick={nextStep}>
                            {activeStep === steps.length ? <FontAwesomeIcon icon={faCheck} className={"me-3"} /> : null}
                            {activeStep === steps.length ? "Concluir" : `Próximo`}
                            {activeStep !== steps.length && <FontAwesomeIcon icon={faArrowRight} className={"ms-3"} />}
                        </Button>
                    </div>
                }
            </div>
        </div>
    );
}
